import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { uniformeModulo } from 'src/app/aplicaciones-modulos/spyral/diccionarios/uniformeModule';

@Injectable({
  providedIn: 'root'
})
export class GroupSizesService {

  diccionarioUrl: any;
  urlUniforme: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlUniforme = this.utilServices.getUniforme();
    this.diccionarioUrl = uniformeModulo.url.uniforme;
  }

  getAllGroupSizes() {
    return this.commom.peticionGetConHeader(this.urlUniforme + this.diccionarioUrl.grupoSize);
  } 

  deleteGroupSize(identificador: string){
    return this.commom.peticionDeleteConHeader(this.urlUniforme + this.diccionarioUrl.grupoSize +'/'+ identificador);
  }

  createGroupSize(parameter: any){
    return this.commom.peticionPostConHeader(this.urlUniforme + this.diccionarioUrl.grupoSize, parameter);
  }

}
